var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerified = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.333 8-1.626-1.86.226-2.46-2.406-.547L10.267 1 8 1.973 5.733 1l-1.26 2.127-2.406.54.226 2.466L.667 8l1.626 1.86-.226 2.467 2.406.546L5.733 15 8 14.02l2.267.973 1.26-2.126 2.406-.547-.226-2.46zm-8.606 3.147-2.534-2.54.987-.987 1.547 1.553 3.9-3.913.986.987z"
  })));
};
export default SvgVerified;